import React from 'react';
import { Spacer } from 'views/components/atoms/Spacer';
import { Image } from 'views/components/atoms/Image';
import iconImage from 'views/components/molecules/ShowExceptionError/images/icon.png';
import { Typography } from 'views/components/atoms/Typography';
import { Color, FontSize } from 'views/constants';
import { Button } from 'views/components/atoms/Button';
import styled from '@emotion/styled';
import { FormattedMessage } from 'react-intl';
import { localeIds } from 'locals';

const Wrapper = styled.div`
  background-color: ${Color.C5};
  text-align: center;
  display: flex;
  flex-direction: column;
  padding: 66px 0;
`;

const LogoIconWrapper = styled.div`
  margin: auto;
  width: 160px;
  height: 156px;
`;

const ButtonWrapper = styled.div`
  width: 280px;
  margin: auto;
`;

type ShowExceptionErrorProps = {
  error: Error;
  sentryId?: string;
  hintLocaleId?: string;
  onBack?(): void;
};

export const ShowExceptionError: React.FC<ShowExceptionErrorProps> = ({
  error,
  sentryId,
  hintLocaleId,
  onBack,
}) => (
  <Wrapper>
    <div>
      <LogoIconWrapper>
        <Image src={iconImage} />
      </LogoIconWrapper>

      <Spacer size="large" />

      <Typography bold>
        <FormattedMessage id={localeIds.showExceptionError.title} />
      </Typography>

      <Spacer size="small" />

      {hintLocaleId ? (
        <Typography size={FontSize.S} color={Color.C16}>
          <FormattedMessage id={hintLocaleId} />
        </Typography>
      ) : (
        <Typography size={FontSize.XS}>
          <FormattedMessage id={localeIds.showExceptionError.subTitle} />
        </Typography>
      )}

      {onBack ? (
        <>
          <Spacer size="large" />
          <ButtonWrapper>
            <Button type="button" style="secondary" onClick={onBack}>
              <FormattedMessage id={localeIds.showExceptionError.back} />
            </Button>
          </ButtonWrapper>
          <Spacer />
        </>
      ) : null}

      <Spacer size="large" />

      <Typography size={FontSize.XS}>Message: {error.message}</Typography>
      {sentryId ? (
        <>
          <Spacer size="small" />
          <Typography size={FontSize.XS}>Error ID: {sentryId}</Typography>
        </>
      ) : null}
    </div>
  </Wrapper>
);
